import React from "react";

export default function About() {
    return (
        <section id="about">
          <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
            <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
              <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white font-zen">
                Web Designer and Front-end Developer
                <br className="hidden lg:inline-block" />
              </h1>
              <p className="mb-8 leading-relaxed font-zen-kaku">
              I'm a freelancer and software engineering student based in Central Wisconsin. I specialize in building and maintaining Wordpress websites.  When I'm not freelancing, I am working on other projects to expand my skillset, hanging out with my dogs, cooking and enjoying the outdoors.
              </p>
              <div className="flex justify-center">
                <a
                  href="#contact"
                  className="inline-flex text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg font-zen">
                  Work With Me
                </a>
                <a
                  href="#projects"
                  className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg font-zen">
                  See My Past Work
                </a>
              </div>
            </div>
            <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
              <img
                className="object-cover object-center rounded-full"
                alt="hero"
                src="./ProfilePhoto_2.png"
              />
            </div>
          </div>
        </section>
      );
}


// WEBPACK FOOTER //
// ./src/components/About.js